<template>
  <div class="audio-format">
    <h2 class="audio-format-title">背景音乐</h2>

    <a-spin :spinning="loadingStatus" :delay="0">
      <!-- 使loading居中 -->
      <!-- 放在spin中会闪烁loading的背景色，所以不放在spin中 -->
      <MediaInterception />
      <div class="icon-tips">
        <span class="icon iconfont tips-icon">&#xe710;</span>
        提示：
      </div>
      <div class="tips-content">
        1.拖动两边滑块，或直接输入音频的起始与结束时间进行截取。
      </div>
    </a-spin>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import MediaInterception from '../base/MediaInterception';

export default {
  name: "MusicMenu",
  components: { MediaInterception },
  data() {
    return {
      loadingStatus: false,
    };
  },
  methods: {
    ...mapActions(["getDefaultMusic"]),
    fetchMusic: function () {
      this.loadingStatus = true;
      this.getDefaultMusic().then(() => {
        this.loadingStatus = false;
      });
    },
  },
  mounted() {
    this.fetchMusic();
  },
  beforeDestroy() {
    this.$store.dispatch('setAudioEditing', false);
  }
};
</script>

<style scoped>
.audio-format {
  padding: 16px;
  box-sizing: border-box;
  /* height: 100%; */
  display: flex;
  flex-flow: column;
}

.audio-format-title {
  font-size: 14px;
  font-weight: 500;
  margin: 0;
}

.audio-format .icon-tips {
  font-size: 12px;
  color: rgba(18, 32, 55, 1);
  margin: 16px 0 5px;
}
.audio-format .tips-icon {
  color: #e4b634;
}
.audio-format .tips-content {
  font-size: 12px;
  color: rgba(101, 102, 103, 1);
}
.audio-format .tips-content + .tips-content {
  margin-top: 10px;
}
</style>